export default __webpack_public_path__ + "static/media/dash-image.37302f7c.svg";